import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { logDebug } from 'in-time-logger';
import { AppStore } from '../../app.store';

export const mustBeSignedInGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
) => {
  const appStore = inject(AppStore);
  const router = inject(Router);

  logDebug(`Auth guard executed for {${route.url}}. Status: ${appStore.isAuthenticated() ? 'ALLOWED' : 'REJECTED'}`);
  if(!appStore.isAuthenticated()) {
    return router.parseUrl('/login');
  }

  return true;
};


export const mustNotBeSignedInGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
) => {
  const appStore = inject(AppStore);
  const router = inject(Router);

  logDebug(`Auth guard executed for {${route.url}}. Status: ${!appStore.isAuthenticated() ? 'ALLOWED' : 'REJECTED'}`);
  if(appStore.isAuthenticated()) {
    return router.parseUrl('/welcome');
  }

  return true;
};
